<template>
<div class="bb-refund-handovers"
>
  <transition name="fade" appear>
    <loader-fly v-if="loaderRun"></loader-fly>
  </transition>
  <div class="bb-refund-handovers-header">
    <h2 class="bb-refund-handovers-header__title">Refunds</h2>
  </div>
  <div v-if="refunds.length >=1" class="bb-refund-handovers-list">
    <div class="bb-refund-handovers-list__empty bb-refund-handovers-list__empty_top"/>
    <div class="bb-refund-handovers-list-item"
         :class="{
              'bb-refund-handovers-list-item_last': index === refunds.length - 1,
              'bb-refund-handovers-list-item_approved': refund.approved
         }"
         v-for="(refund, index) in refunds"
         :key="refund.id"
    >
      <div class="bb-refund-handovers-list-item-approved">
        <CircleCheckbox v-if="refund.approved" :disabled="true" :value="refund.approved"/>
        <i class="icon-edit
                  bb-icon
                  bb-icon_accent
                  bb-refund-handovers-list-item-approved__edit"
           @click.stop="editRefund = refund"
           v-else
        />
      </div>
      <div class="bb-refund-handovers-list-item-info">
        <div class="bb-refund-handovers-list-item-info__label">{{refund.label}}</div>
        <div class="bb-refund-handovers-list-item-info__draft" v-if="!refund.approved">
          Draft
        </div>
      </div>
      <div class="bb-refund-handovers-list-item-date">
        <div v-if="refund.approved">{{formatDate(refund.date)}}</div>
        <DataPicker v-else
                    :obj="refund"
                    @setDate="setApprovedDate"
                    :default-date="new Date()"/>
      </div>
      <div  v-if="!refund.approved"
            class="bb-refund-handovers-list-item-controls"
            @mouseleave="hideAllPopup"
      >
        <template>
          <div class="bb-refund-handovers-list-item-controls-upload">
            <Upload :multiple="true"
                    :popup-down="true"
                    :files="refund.uploadFile"
                    :item="refund"
                    :view="refund.uploadFile && refund.uploadFile.length > 0"
                    :upload="refund.uploadFile.length !== 2"
                    :displayDelete="true"
                    :fixed="true"
                    @statusUpload="setDisabledSave"
                    @delete="deleteFile"
                    @view="downloadFile"
                    @upload="uploadFile"/>
          </div>
          <i class="icon-trash-1 bb-icon bb-icon_red" @click="setRefundDelete($event, refund)"/>
          <transition name="bounce">
            <div class="bb-refund-handovers-list-item-controls-delete"
                 :style="{
                       position: deletePosition.top ? 'fixed' : 'absolute',
                       top: deletePosition.top + 30 + 'px',
                       left: deletePosition.left - 95 + 'px'
                   }"
                 v-if="deleteRefundId === refund.id"
            >
              <span class="bb-refund-handovers-list-item-controls-delete__title">Are you sure?</span>
              <div class="bb-refund-handovers-list-item-controls-delete-buttons">
                <button class="bb-button
                               bb-refund-handovers-list-item-controls-delete-buttons__item"
                        type="submit"
                        @click.stop="deleteRefund"
                >
                  Yes
                </button>
                <button class="bb-button
                               bb-refund-handovers-list-item-controls-delete-buttons__item"
                        type="submit"
                        @click.stop="deleteRefundId = false"
                >
                  No
                </button>
              </div>
            </div>
          </transition>
          <button class="bb-button
                         bb-refund-handovers-list-item-controls__accept"
                  @mouseenter="hideAllPopup"
                  @click="approveRefund(refund)"
                  :disabled="refund.uploadFile.length !== 2"
          >
            SAVE
          </button>
        </template>
      </div>
      <div v-else class="bb-refund-handovers-list-item-approved-refund">
        <div>
          <RefundCreditNotes :limitCount="limitCount"
                             :fixedPopup="true"
                             @openTaxCreditNote="openTaxCreditNote"
                             :soaCreditNotes="refund.soaCreditNotes"/>
        </div>
        <div>
          <span class="bb-refund-handovers-list-item-approved-refund-tags">
            {{getNameType(refund)}}
          </span>
        </div>
        <div>AED {{numeralConvertNumber(refund.balance)}}</div>
        <div class="bb-refund-handovers-list-item-controls-upload">
          <Upload :multiple="true"
                  :popup-down="true"
                  :files="refund.uploadFile"
                  :item="refund"
                  :view="refund.uploadFile && refund.uploadFile.length > 0"
                  :upload="refund.uploadFile.length !== 2"
                  :displayDelete="false"
                  :fixed="true"
                  @statusUpload="setDisabledSave"
                  @view="downloadFile"/>
        </div>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow
        v-if="editRefund.id"
        @close="editRefund = {}"
        :without-padding="true"
      >
        <RefundHandoverForm
          @close="editRefund = {}"
          :refund="editRefund"
          :selectedDocuments="editRefund.soaCreditNotes"
          @update="updateRefund"
        />
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="creditNoteProforma" @close="closeCreditNoteProforma">
        <template v-slot:buttons>
          <div class="bb-refund-handovers__send">
            <ButtonsEdit :left-if="false"
                         @delete="proformaEvents.cancel()"
                         no-pop-up="false"
                         btn-right-text="CANCEL"
                         styles="accent"/>
          </div>
        </template>
        <CreditNoteProforma ref="proformaCreditNote"
                            :editableSoaCreditNote="editableSoaCreditNote"
                            @close="closeCreditNoteProforma"
                            :view-mode="true"/>
      </ModalWindow>
    </transition>
  </div>
  <TableNoData v-else :description="descriptionText"/>
</div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import SoaRefundApi from '@/api/SoaRefund/api'
import UploadFileApi from '@/api/UploadFile/api'
import setFileData from '@/mixin/setFileData'
import convertNumber from '@/mixin/convertNumber'
import CircleCheckbox from '@/components/Main/Inputs/CircleCheckbox'
import TableNoData from '@/components/Main/BBTable/TableNoData/TableNoData'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import paymentTypes from '@/constants/paymentTypes'
import CreditNoteProforma from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteProforma'
import Upload from '@/components/Main/Upload/Upload'
import SoaCreditNote from '@/api/SoaCreditNote/api'
import RefundCreditNotes
  from '@/components/Dissemination/Sales/CRM/ContactCard/RefundHandovers/RefundHandoversList/RefundCreditNotes'
import {findIndex, get, forEach, uniqueId, cloneDeep, find} from 'lodash'
import {saveAs} from 'file-saver'
import b64toBlob from 'b64-to-blob'
import moment from 'moment'
import RefundHandoverForm
  from '@/components/Dissemination/Sales/CRM/ContactCard/RefundHandovers/RefundHandoverForm/RefundHandoverForm'
export default {
  name: 'RefundHandoversList',
  mixins: [setFileData, convertNumber],
  components: {
    LoaderFly,
    ModalWindow,
    Upload,
    CircleCheckbox,
    TableNoData,
    CreditNoteProforma,
    ButtonsEdit,
    RefundCreditNotes,
    RefundHandoverForm,
    DataPicker
  },
  computed: {
    clientInfo () {
      return this.$store.getters.clientInfo
    },
    fileName () {
      const label = get(this.currentFile, 'file.label', '')
      const name = get(this.currentFile, 'file.name', '')
      return name || label
    }
  },
  data () {
    return {
      loaderRun: false,
      fileToolbar: false,
      editRefund: {},
      filePosition: {},
      deleteRefundId: false,
      creditNoteProforma: false,
      editableSoaCreditNote: '',
      deletePosition: {},
      currentFile: {},
      limitCount: 1,
      disableSave: false,
      paymentTypes: [],
      descriptionText: 'Sorry, but not found Refunds',
      currentFileTwo: {},
      proformaEvents: {
        cancel: false
      },
      files: {},
      crypt: true,
      refunds: []
    }
  },
  methods: {
    getRefundList () {
      this.loaderRun = true
      const client = this.clientInfo.id
      SoaRefundApi.getRefund({
        client
      })
        .then((resp) => {
          this.loaderRun = false
          this.refunds = resp.data.soarefunds.map(item => item)
        })
        .catch((e) => {
          this.loaderRun = false
          console.error(e)
        })
    },
    updateRefund () {
      this.getRefundList()
    },
    approveRefund (refund) {
      SoaRefundApi.approveRefund(refund.id)
        .then(() => {
          this.getRefundList()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getNameType (refund) {
      const paymentType = get(refund, 'paymentType', 1)
      this.paymentTypes = paymentTypes
      const res = find(this.paymentTypes, item => item.id === paymentType)
      return res ? res.name : ''
    },
    hideAllPopup () {
      this.deleteRefundId = false
      this.fileToolbar = false
    },
    setDisabledSave (val) {
      this.disableSave = val
    },
    clearFile () {
      const fileId = get(this.currentFile, 'file.id', '')
      if (fileId) UploadFileApi.deleteFile(fileId, this.crypt)
      this.setDefaultCurrentFile()
    },
    downloadFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file.id)
    },
    closeCreditNoteProforma () {
      this.editableSoaCreditNote = ''
      this.creditNoteProforma = false
    },
    openTaxCreditNote (creditNote) {
      const creditNoteId = get(creditNote, 'id', '')
      if (!creditNoteId) return
      this.loaderRun = true
      SoaCreditNote.getSoaCreditNotesById(creditNoteId)
        .then(({data}) => {
          this.loaderRun = false
          this.editableSoaCreditNote = data
          this.creditNoteProforma = true
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getFile (id) {
      UploadFileApi.getFile(id, this.crypt)
        .then(({data}) => {
          const {base64, type, id, label} = data
          const blob = b64toBlob(base64, type)
          this.files[id] = {id: id, blob, label: label}
          saveAs(blob, label)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setFileControl (e, refund) {
      this.filePosition = e.target.getBoundingClientRect()
      this.fileToolbar = refund.id
      this.deleteRefundId = false
    },
    deleteFile (fileId, refund) {
      const fileIndex = findIndex(refund.uploadFile, {id: fileId})
      if (fileIndex === -1) return
      refund.uploadFile.splice(fileIndex, 1)
      this.refundUpdate(refund)
    },
    refundUpdate (refund) {
      const refundClone = cloneDeep(refund)
      refundClone.uploadFile = refund.uploadFile.map(item => item.id)
      SoaRefundApi.updateRefund(refundClone)
        .then(() => {})
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    uploadFile (files, refund) {
      forEach(files, file => {
        const fileId = uniqueId('file_')
        refund.uploadFile.push({$id: fileId, label: file.name})
        const fileData = new FormData()
        fileData.set('fieldname', 'uploadFile')
        fileData.set('label', file.name || '')
        fileData.set('file', file)
        const fileIndex = findIndex(refund.uploadFile, {$id: fileId})
        UploadFileApi.createFile(fileData, this.crypt)
          .then((resp) => {
            if (fileIndex === -1) return
            refund.uploadFile.splice(fileIndex, 1, resp.data)
            this.refundUpdate(refund)
          })
          .catch((err) => {
            if (fileIndex !== -1) {
              refund.uploadFile.splice(fileIndex, 1)
            }
            console.error(err)
          })
      })
    },
    setDefaultCurrentFile () {
      this.currentFile = {
        id: '',
        status: false,
        file: {}
      }
      this.currentFileTwo = {
        id: '',
        status: false,
        file: {}
      }
    },
    formatDate (date) {
      if (date) {
        return moment(date).format('DD-MMM-YY')
      } else {
        return ''
      }
    },
    setApprovedDate (date, refund) {
      refund.date = date
    },
    setRefundDelete (e, refund) {
      this.deletePosition = e.target.getBoundingClientRect()
      this.deleteRefundId = refund.id
    },
    deleteRefund () {
      if (!this.deleteRefundId) return
      const refundIndex = findIndex(this.refunds, {id: this.deleteRefundId})
      if (refundIndex !== -1) {
        this.refunds.splice(refundIndex, 1)
      }
      SoaRefundApi.deleteRefund(this.deleteRefundId)
        .then(() => {})
        .catch((e) => {
          console.error(e)
        })
    }
  },
  updated () {
    if (this.$refs.proformaCreditNote) {
      this.proformaEvents.cancel = this.$refs.proformaCreditNote.cancelProforma
    }
  },
  beforeMount () {
    this.setDefaultCurrentFile()
    this.getRefundList()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-refund-handovers {
    @include global-font;
    min-width: 800px;

    &-header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 25px;
      color: $color-accent;

      &__title {
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
      }
    }

    &__send {
      position: relative;
      padding-bottom: 0;
      padding-top: 30px;
      margin-right: 8px;
      display: flex;
      justify-content: flex-end;
      box-shadow: 0 -10px 35px -15px rgba($color-silver, 0.4);
    }

    &-list {
      position: relative;
      display: grid;
      grid-gap: 7px;
      max-height: calc(100vh - 280px);

      &__empty {
        position: sticky;
        width: 100%;
        height: 15px;
        background-color: $color-white;
        z-index: 10;

        &_top {
          top: 0
        }
      }

      &-item {
        display: grid;
        grid-template-columns: 21px minmax(200px, 300px) minmax(109px, 354px) auto;
        grid-gap: 10px;
        align-items: center;
        padding: 8px 20px;
        min-height: 52px;
        width: 100%;
        background: $color-white;
        box-shadow: 0 0 20px rgba($color-black, 0.05);
        border-radius: 5px;
        font-size: 13px;
        line-height: 16px;
        cursor: default;
        transition: 0.4s;

        &_approved {
          grid-template-columns: 21px minmax(117px, 134px) minmax(57px, 162px) auto;
          align-items: center;
        }

        &_last {
          margin-bottom: 7px;
        }

        &-approved {
          &__edit {
            font-size: 21px;
            width: 21px;
            height: 21px;
          }
        }

        &-info {
          display: flex;
          align-items: center;

          &__label {
            font-weight: 500;
            margin-right: 15px;
            margin-left: 9px;
          }

          &__draft {
            color: $color-jaffa;
            padding: 4px 6px;
            border: 1px solid rgba($color-jaffa, 0.14);
            box-sizing: border-box;
            border-radius: 4px;
          }
        }

        &-controls {
          display: grid;
          grid-template-columns: 25px 25px 25px 65px;
          align-items: center;
          grid-column-gap: 8px;

          &__accept {
            min-width: 91px;
            margin-left: 14px;
            height: 36px;
          }

          &-upload {
            position: relative;
            width: 25px;
            height: 25px;
            transition: 0.3s;
            margin-top: 5px;

            &:hover &__icon {
              &:after {
                background-color: $color-accent-hover
              }
            }

            &__input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 21px;
              opacity: 0;
              padding: 21px 21px 0 0;
              cursor: pointer;
              z-index: 3;
            }

            &-loader {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 25px;
              height: 25px;
              border-radius: 50%;
              background-color: $color-wild-sand;

              &__border {
                border: 1px solid $color-accent;
                box-sizing: border-box;
                border-radius: 16px;
                width: 15px;
                height: 5px;
              }

              &__progress {
                display: block;
                background-color: $color-accent;
                width: 50%;
                height: 100%;
                transition: .3s;
                animation: loader 3s linear infinite;
              }
            }
          }

          &-delete {
            position: absolute;
            top: 30px;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: $color-white;
            box-shadow: 0 0 15px rgba($color-black, 0.05);
            border-radius: 5px;
            z-index: 12;
            padding: 14px;
            width: 120px;
            color: $color-black;
            cursor: default;

            &_file {
              display: grid;
              grid-template-columns: 1fr 13px;
              align-items: start;
              grid-gap: 10px;
              font-size: 13px;
              width: 150px;
              word-break: break-word;
            }

            &__filename {
              cursor: pointer;
              transition: .3s;

              &:hover {
                opacity: 0.6;
              }
            }

            &__remove {
              cursor: pointer;
              color: $color-silver-chalice;
              border-radius: 2px;
              transition: .3s;

              &:hover {
                opacity: 0.6;
              }
            }

            &_top {
              bottom: 0;
              top: auto;
            }

            &__title {
              font-size: 14px;
              line-height: 17px;
            }

            &-buttons {
              display: grid;
              grid-template-columns: 39px 39px;
              grid-gap: 10px;
              justify-content: center;
              align-items: center;
              width: 100%;
              margin-top: 13px;

              &__item {
                font-size: 12px;
                line-height: 14px;
                width: 39px;
                height: 26px;
              }
            }
          }
        }

        &-approved-refund {
          display: grid;
          grid-template-columns: minmax(172px, 242px) minmax(42px, 112px) minmax(81px, 150px) auto;
          align-items: center;

          &-tags {
            padding: 4px 6px;
            background: rgba($color-accent, 0.14);
            border-radius: 4px;
            font-weight: 500;
            color: $color-accent;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
              color: $color-accent-hover;
              background: rgba($color-accent-hover, 0.14);
            }
          }
        }
      }
    }
  }

  @keyframes loader {
    from {
      width: 0;
    }

    to {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/RefundHandovers/RefundHandoversList/RefundHandoversList.vue